"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var meta_knowledge_provider_service_1 = require("../../../../../../shared/services/api/meta-knowledge-provider.service");
var takeUntil_1 = require("rxjs/operators/takeUntil");
var sub_entity_filter_1 = require("../../model/api/sub-entity-filter");
var SubEntityFilterComponent = /** @class */ (function () {
    function SubEntityFilterComponent(metaKnowledgeProviderService, classifierService) {
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        this.classifierService = classifierService;
        this.filter = new core_1.EventEmitter();
        this._destroy$ = new Subject_1.Subject();
    }
    SubEntityFilterComponent.prototype.ngOnInit = function () {
        var caseInsensitiveFields = this.subEntityFilterConfig.map(function (field) { return field.toLowerCase(); });
        this._initFilterVisibilityFlags(caseInsensitiveFields);
        if (this._withTypeId) {
            this._loadDocumentTypes();
        }
        else {
            this._isReady = true;
        }
    };
    SubEntityFilterComponent.prototype._initFilterVisibilityFlags = function (caseInsensitiveFields) {
        this._withDescription = caseInsensitiveFields.includes('description');
        this._withTitle = caseInsensitiveFields.includes('title');
        this._withTypeId = caseInsensitiveFields.includes('type');
        this._withSigned = caseInsensitiveFields.includes('signed');
    };
    SubEntityFilterComponent.prototype._loadDocumentTypes = function () {
        var _this = this;
        var documentTypeDefinition$ = this.metaKnowledgeProviderService.getDocumentTypeDefinition(this.rootCategory);
        documentTypeDefinition$
            .pipe(operators_1.switchMap(function (documentTypeDefinition) {
            return _this.classifierService.loadClassifiersView(documentTypeDefinition.typeIdCategoryId);
        }), takeUntil_1.takeUntil(this._destroy$))
            .subscribe(function (typeClassifiers) {
            _this._typeClassifiers = typeClassifiers;
            _this._isReady = true;
        });
    };
    SubEntityFilterComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    SubEntityFilterComponent.prototype.onTypeChange = function (value) {
        this._type = value;
        this.emitFilter();
    };
    SubEntityFilterComponent.prototype.onTitleChange = function (value) {
        this._title = value;
        this.emitFilter();
    };
    SubEntityFilterComponent.prototype.onDescriptionChange = function (value) {
        this._description = value;
        this.emitFilter();
    };
    SubEntityFilterComponent.prototype.onSignedChange = function (isSigned) {
        this._isSigned = isSigned;
        this.emitFilter();
    };
    SubEntityFilterComponent.prototype.emitFilter = function () {
        var subEntityFilter = this.constructFilter();
        this.filter.emit(subEntityFilter);
    };
    SubEntityFilterComponent.prototype.constructFilter = function () {
        return new sub_entity_filter_1.SubEntityFilter(this._type, this._title, this._description, this._isSigned);
    };
    Object.defineProperty(SubEntityFilterComponent.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "title", {
        get: function () {
            return this._title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "isSigned", {
        get: function () {
            return this._isSigned;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "typeClassifiers", {
        get: function () {
            return this._typeClassifiers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "withTypeId", {
        get: function () {
            return this._withTypeId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "withTitle", {
        get: function () {
            return this._withTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "withDescription", {
        get: function () {
            return this._withDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubEntityFilterComponent.prototype, "withSigned", {
        get: function () {
            return this._withSigned;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SubEntityFilterComponent.prototype, "rootCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SubEntityFilterComponent.prototype, "subEntityFilterConfig", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], SubEntityFilterComponent.prototype, "filter", void 0);
    SubEntityFilterComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-sub-entity-filter',
            styles: [require('./sub-entity-filter.component.css')],
            template: require('./sub-entity-filter.component.html')
        }),
        __metadata("design:paramtypes", [meta_knowledge_provider_service_1.MetaKnowledgeProviderService,
            idm_classifier_service_client_js_1.ClassifierService])
    ], SubEntityFilterComponent);
    return SubEntityFilterComponent;
}());
exports.SubEntityFilterComponent = SubEntityFilterComponent;
//# sourceMappingURL=sub-entity-filter.component.js.map